module.exports = __webpack_public_path__ + "img/laser-turret-gun-start-mask.27ff34af.png";